import { QueryClientProvider } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';

import { ConsentProvider } from '@features/consent';
import { i18n, initI18n } from '@shared/i18n';

import { createQueryClient } from './queryClient';

initI18n();

interface ProvidersProps {
  children: ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  const [queryClient] = useState(createQueryClient);

  return (
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        {/* Согласие живёт над всем приложением: решение действует на всё, а не
            на страницу. Провайдер внутри QueryClientProvider — он читает
            объявленные категории из `GET /config`. */}
        <ConsentProvider>{children}</ConsentProvider>
      </QueryClientProvider>
    </I18nextProvider>
  );
}
